import React, { ComponentProps, FunctionComponent } from "react";

const TrendUpIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 17",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M30 1.32032V7.21657C30 7.94823 29.4023 8.53869 28.6617 8.53869C27.921 8.53869 27.3233 7.94823 27.3233 7.21657V4.40017L18.5354 13.0817C18.0318 13.5792 17.1431 13.5792 16.6394 13.0817L11.2495 7.75882L2.28719 16.6127C2.02406 16.8726 1.68075 17 1.34095 17C0.997656 17 0.654343 16.8726 0.394707 16.6127C-0.131569 16.0962 -0.131569 15.2595 0.394707 14.7448L10.3033 4.95269C10.8034 4.45861 11.6956 4.45861 12.194 4.95269L17.5821 10.2809L25.3123 2.64426H22.6897C21.9543 2.64426 21.3514 2.0538 21.3514 1.32213C21.3514 0.590466 21.9543 3.75432e-06 22.6897 3.75432e-06H28.6582C29.4023 -0.00171765 30 0.588658 30 1.32032Z",
      fill: "currentColor",
    })
  );
};

const ForwardedRefIcon = React.forwardRef(TrendUpIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardedRefIcon;
